(function(){'use strict';
function boot(){
  document.querySelectorAll('.header-nav__item--shop').forEach(function(shop){
    var mega=shop.querySelector('.luveqo-shop-mega,.sarte-mega'); if(!mega||shop.dataset.cleanBound)return;
    shop.dataset.cleanBound='1'; var timer;
    function open(){clearTimeout(timer);shop.classList.add('clean-mega-open');}
    function close(){clearTimeout(timer);timer=setTimeout(function(){shop.classList.remove('clean-mega-open');},220);}
    shop.addEventListener('mouseenter',open);shop.addEventListener('mouseleave',close);
    mega.addEventListener('mouseenter',open);mega.addEventListener('mouseleave',close);
  });
  document.querySelectorAll('[data-sarte-cats]').forEach(function(root){
    var rail=root.querySelector('[data-rail]');if(!rail)return;
    root.querySelectorAll('.sarte-circle-btn[data-scroll]').forEach(function(btn){
      if(btn.dataset.cleanBound)return;btn.dataset.cleanBound='1';btn.disabled=false;btn.removeAttribute('disabled');
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
        var dir=parseInt(btn.getAttribute('data-scroll'),10)||0;
        var first=rail.firstElementChild,gap=parseFloat(getComputedStyle(rail).gap||'16')||16;
        var step=(first?first.getBoundingClientRect().width:280)+gap,max=Math.max(0,rail.scrollWidth-rail.clientWidth);
        if(!max)return;
        var target=rail.scrollLeft+dir*step;
        if(dir<0&&target<=1)target=max;if(dir>0&&target>=max-1)target=0;
        rail.scrollTo({left:target,behavior:'smooth'});
      },true);
    });
  });
  document.querySelectorAll('[data-footer-toggle]').forEach(function(head){
    if(head.dataset.cleanBound)return;head.dataset.cleanBound='1';
    head.addEventListener('click',function(e){
      if(window.innerWidth>749)return;e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      var col=head.closest('.footer-col'),list=col&&col.querySelector('.footer-col__list');if(!col||!list)return;
      var open=col.classList.toggle('is-open');head.setAttribute('aria-expanded',open?'true':'false');list.style.maxHeight=open?list.scrollHeight+'px':'0';
    },true);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
})();